module.exports = __webpack_public_path__ + "static/media/icon.e0ea0e03.svg";